module.exports = __webpack_public_path__ + "img/img0.d8dba430.jpg";